import { Dispatch } from '@reduxjs/toolkit';
import { IState } from '.';
import { IEntityWithMessages } from '../services/HttpService';
import { IApiExecuteRespone } from './apiInterfaces';
import { isUser } from './auth';
import { uiActionCreators } from './ui';

const defValidation = 'There was a problem validating this action.  Please fix the following problems and retry.';
const defError = 'There was a problem performing this action.  Please retry, if the problem persists contact IT.';

export function processMessagesThunk({
  dispatch,
  errorText = defError,
  response,
  validationText = defValidation
}: {
  response: IEntityWithMessages<any>;
  validationText?: string;
  errorText?: string;
  dispatch: Dispatch;
}) {
  if (response.messages.length > 0) {
    dispatch(
      uiActionCreators.showMessageDialog({
        messages: response.messages,
        title: validationText
      })
    );
  }

  if (response.exception) {
    dispatch(
      uiActionCreators.showMessageDialog({
        exception: response.exception,
        messages: [
          `An exception occured trying to perform this action.
          Please retry.  If this problem persists, contact IT`
        ],
        title: 'An error occured!'
      })
    );
  }
}

export function showFailedRequestDialogThunk(response: IApiExecuteRespone<any>, state: IState, dispatch: Dispatch) {
  const itUser = isUser(state, 'it');

  let messages: string[] = [
    `An exception occured trying to perform this action.
    Please retry.  If this problem persists, contact IT`
  ];

  if (itUser && response.exception) {
    messages = [...messages, `Exception Message: ${response.exception.message}`];
  }

  dispatch(
    uiActionCreators.showMessageDialog({
      exception: response.exception,
      messages,
      title: 'An error occured!'
    })
  );
}
